/**
 * Shared constants/helpers for cookie-consent state.
 *
 * The cookie banner mirrors the user's analytics choice into localStorage and
 * dispatches a window event so the rest of the app (Consent Mode v2 + Vercel
 * Analytics gating) can react without coupling to the banner component.
 */
export const ANALYTICS_CONSENT_KEY = "exos_analytics_consent";
export const CONSENT_CHANGED_EVENT = "exos:consent-changed";

/** Read the stored analytics-consent flag. Returns false when unset/blocked. */
export function readAnalyticsConsent(): boolean {
  try {
    return localStorage.getItem(ANALYTICS_CONSENT_KEY) === "granted";
  } catch {
    return false;
  }
}
